// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3w5lg","inner":"Footer_inner__10he6","nextIcon":"Footer_nextIcon__1f9gY","innerLeft":"Footer_innerLeft__1Jq_M"};